<template>
    <div class="wrapper__mask-design">
        <div class="wrapper__container">
            <div class="wrapper__mask-design__content">
                <div class="wrapper__mask-design__stickers">
                    <div
                        class="sticker"
                        v-for="(sticker, stickerIndex) in toolbar.stickers"
                        :key="'sticker-' + stickerIndex"
                        v-on:click="onClickStickerHandler(sticker)"
                        v-on:dragstart="onDragStart(sticker, $event)"
                    >
                        <img :src="sticker"/>
                    </div>
                </div>

                <div class="wrapper__mask-design__creator">
                    <div
                        class="mask"
                        :style="customCursorStyle"
                        v-on:dragover="allowDrop"
                    >
                        <canvas
                            id="mask__element"
                            :width="canvas.width"
                            :height="canvas.height"
                        ></canvas>
                        <div
                            v-if="canvas.silhouette !== ''"
                            class="mask__silhouette"
                            :style="{
                                width: canvas.width + 'px',
                                height: canvas.height + 'px'
                            }"
                        >
                            <img
                                ref="silhouette"
                                :src="canvas.silhouette"
                            />
                        </div>
                        <div
                            v-if="canvas.topLayer !== ''"
                            class="mask__top-layer"
                            :style="{
                                width: canvas.width + 'px',
                                height: canvas.height + 'px'
                            }"
                        >
                            <img
                                ref="topLayer"
                                :src="canvas.topLayer"
                            />
                        </div>
                    </div>

                    <p class="wrapper__btn wrapper__mask-design__text">
                        Your face mask will be judged on originality,<br>
                        creativity, connecting to the Back-to-Cool theme,<br>
                        and showcasing your best art skills!<br>
                        <br>
                        Accepting submissions September 10th <br>
                        through September 21st!
                    </p>

                    <button
                        v-trackevent:val="'mask-design_submit-mask_btn'"
                        class="wrapper__btn wrapper__mask-design__button"
                        @click="submit"
                    ></button>
                </div>

                <div class="wrapper__mask-design__tools">
                    <div class="wrapper__mask-design__tools__colors">
                        <div
                            class="color"
                            v-for="(color, colorIndex) in canvas.palette"
                            :key="'color-' + colorIndex"
                            v-on:click="onClickColorHandler(color)"
                        >
                            <div
                                :class="{
                                    'color__content': true,
                                    'is-selected': (brushColor === color),
                                    'square': (brushShape === 'square'),
                                    'round': (brushShape === 'round')
                                }"
                            >
                                <div
                                    class="color__content__color"
                                    :style="{
                                        'background-color': color
                                    }"
                                ></div>
                            </div>
                        </div>
                    </div>

                    <div class="wrapper__mask-design__tools__sizes">
                        <div
                            class="size"
                            v-for="(size, sizeIndex) in canvas.sizes"
                            :key="'size-' + sizeIndex"
                            v-on:click="onClickSizeHandler(size)"
                        >
                            <div
                                :class="{
                                    'size__content': true,
                                    'is-selected': (brushSize === size),
                                    'square': (brushShape === 'square'),
                                    'round': (brushShape === 'round')
                                }"
                            >
                                <div
                                    class="size__content__size"
                                    :style="{
                                        width: size + 'px',
                                        height: size + 'px',
                                        'background-color': brushColor
                                    }"
                                ></div>
                            </div>
                        </div>
                    </div>

                    <button
                        v-trackevent:val="'mask-design_undo_btn'"
                        class="wrapper__btn wrapper__mask-design__tools__undo"
                        @click="undo"
                    ></button>
                    <button
                        v-trackevent:val="'mask-design_start-over_btn'"
                        class="wrapper__btn wrapper__mask-design__tools__startover"
                        @click="startOver"
                    ></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CONFIG from '@/config';
    import Canvas from '@/components/Canvas';
    import _ from 'lodash';

  export default {

    name: 'MaskDesign',

    data() {

        return {
            toolbar: {
                stickers: CONFIG.settings.mask.toolbar.stickers || [],
            },
            canvas: {
                width: 420,
                height: 240,
                instance: null,
                silhouette: CONFIG.settings.mask.silhouette || '',
                topLayer: CONFIG.settings.mask.topLayer || '',
                cursor: CONFIG.settings.mask.customCursor || '',
                brushColor: '#000000',
                brushSize: 12,
                brushShape: 'round',
                palette: CONFIG.settings.mask.toolbar.palette || [],
                shapes: CONFIG.settings.mask.toolbar.shapes || [],
                sizes: CONFIG.settings.mask.toolbar.brushSizes || []
            }
        };
    },

    mounted() {
         try {
            this.canvas.instance = new Canvas('mask__element', this.canvas);
            this.canvas.instance.init();
        } catch (e) {
            console.log('catch', e);
        }
    },

    computed: {

        customCursorStyle () {
            let cursor = '' ;//'url(' + this.canvas.cursor + '), auto';

            if (
                this.canvas.instance
                &&
                this.canvas.instance.currentSticker
            ) {
                if (this.canvas.instance.currentSticker.isResizing) {
                    cursor = this.canvas.instance.currentSticker.cursor;
                } else if (this.canvas.instance.currentSticker.isDragging) {
                    cursor = 'move';
                } else {
                    cursor = 'grab';
                }
            }

            return {
                cursor
            };
        },

        brushSize () {
            return this.canvas.instance !== null ? this.canvas.instance.brushSize : this.canvas.brushSize;
        },

        brushShape () {
            return this.canvas.instance !== null ? this.canvas.instance.brushShape : this.canvas.brushShape;
        },

        brushColor () {
            return this.canvas.instance !== null ? this.canvas.instance.brushColor : this.canvas.brushColor;
        }
    },

    methods: {

        onClickStickerHandler(sticker) {
            this.canvas.instance.setSticker(sticker);
        },

        onDragStart (sticker, event) {
            event.dataTransfer.setData('sticker', sticker);
        },

        allowDrop (event) {
            event.preventDefault();
        },

        onClickColorHandler(color) {
            this.canvas.instance.setBrushColor(color);
        },

        onClickSizeHandler (size) {
            this.canvas.instance.setBrushSize(size);
        },

        undo() {
            this.canvas.instance.undo();
        },

        startOver() {
            this.canvas.instance.clearCanvas();
        },

        submit() {
            this.canvas.instance.repaint([this.$refs.silhouette, this.$refs.topLayer]);
            this.$emit('changePage', this.canvas.instance.canvas.toDataURL());
        }
    }
  }
</script>

<style scoped lang="scss">
    .wrapper__mask-design {
        align-items: center;
        justify-content: center;
        display: flex;
        height: 100%;
        position: relative;
        width: 100%;

        &__content {
            width: 100%;
            height: 394px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
        }

        &__stickers,
        &__tools {
            height: 394px;
            float: left;
            position: relative;
            width: 247px;
        }

        &__stickers {
            background-image: url('/images/mask-design_stickers.png');
            padding: 164px 66px 0px 60px;
            box-sizing: border-box;

            .sticker {
                float: left;
                height: 62px;
                text-align: center;
                width: 60px;

                img {
                    // transform: scale(0.2);
                    max-width: 50px;
                    max-height: 50px;
                }
            }
        }

        &__creator {
            height: 394px;
            float: left;
            position: relative;
            text-align: center;
            width: 506px;

            .mask {
                position: relative;
                height: 240px;
                margin: 0px auto;
                width: 420px;

                &__silhouette,
                &__top-layer {
                    position: absolute;
                    top: 0;
                    left: 0;
                    pointer-events: none;
                    display: flex;
                    justify-content: center;

                    .img {
                        object-fit: contain;
                    }
                }
            }
        }

        &__tools {
            background-image: url('/images/mask-design_tools.png');

            &__colors {
                position: absolute;
                top: 96px;
                left: 44px;
                overflow: hidden;
                width: 152px;

                .color {
                    float: left;
                    width: 21px;
                    margin: 8px;
                    text-align: center;
                    height: 21px;

                    // Exception
                    &:nth-of-type(3) {
                        .color__content__color {
                            border: 1px solid #e3c924;
                            width: 15px;
                            height: 15px;
                        }
                    }

                    &__content {
                        box-sizing: content-box;
                        border: 2px solid transparent;
                        width: 21px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 21px;

                        &.is-selected {
                            border: 2px solid #8bb13d;

                            .color__content__color {
                                border: 2px solid #FFFFFF;
                                margin: 0px;
                            }
                        }

                        &.round {
                            border-radius: 50%;

                            .color__content__color {
                                border-radius: 50%;
                            }
                        }

                        &__color {
                            margin: 2px;
                            width: 17px;
                            height: 17px;
                        }
                    }
                }
            }

            &__sizes {
                position: absolute;
                top: 243px;
                left: 44px;
                overflow: hidden;
                width: 152px;

                .size {
                    float: left;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 44px;
                    width: 38px;

                    &__content {
                        box-sizing: content-box;
                        border: 2px solid transparent;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        &.is-selected {
                            border: 2px solid #8bb13d;

                            .size__content__size {
                                border: 2px solid #FFFFFF;
                                margin: 0px;
                            }
                        }

                        &.round {
                            border-radius: 50%;

                            .size__content__size {
                                border-radius: 50%;
                            }
                        }
                    }
                }
            }


            &__undo,
            &__startover {
                bottom: 29px;
                height: 44px;
                position: absolute;
                width: 71px;
            }

            &__undo {
                background-image: url('/images/mask-design_undo.png');
                left: 45px;

                &:hover {
                    background-image: url('/images/mask-design_undo-hover.png');
                }
            }

            &__startover {
                background-image: url('/images/mask-design_startover.png');
                right: 51px;

                &:hover {
                    background-image: url('/images/mask-design_startover-hover.png');
                }
            }
        }

        &__text {
            color: #5f9d3e;
            font-family: 'Open Sans', sans-serif;
            font-weight: bold;
            font-size: 16px;
            line-height: 18px;
            left: 50%;
            text-align: center;
            position: absolute;
            bottom: -76px;
            transform: translateX(-50%);
            width: 410px;
        }

        &__button {
            background-image: url('/images/mask-design_submit.png');
            bottom: 60px;
            height: 73px;
            left: 50%;
            position: absolute;
            transform: translateX(-50%);
            width: 269px;

            &:hover {
                background-image: url('/images/mask-design_submit-hover.png');
            }
        }
    }
</style>
